import React from 'react';

import Artwork from 'components/base/Artwork/Artwork';
import ArtistLinks from '../EntityMetadata/ArtistLinks';
import Artist from 'components/Header/EntityMetadata/entities/Artist';
import {
  ArtistElement,
  BreadcrumbWrapper,
  CaretIcon,
  MobileAnchor,
} from './Breadcrumb.style';
import BreadcrumbLoader from './BreadcrumbLoader';
import useMedia from 'hooks/useMedia';
import getEntityUrl from 'url-constructors/getEntityUrl';
import { ContextTopics } from 'context/entityContext';

interface IBreadcrumbsProps {
  loading: boolean;
  artists: any;
  topic: ContextTopics;
}

const Breadcrumbs: React.FC<IBreadcrumbsProps> = (props) => {
  const { loading, artists, topic } = props;

  const isMobile = useMedia('(max-width: 799px)');

  return (
    <BreadcrumbWrapper isMobile={isMobile}>
      {artists && !loading ? (
        artists.map(
          (artist: any): JSX.Element => (
            <ArtistElement
              key={artist.artist.id}
              isMobile={isMobile}
              data-pw="artist-info-block"
            >
              {!isMobile ? (
                <>
                  <Artwork
                    key={`entity-artwork-${artist.artist.id}`}
                    entityId={artist.artist.id}
                    entityType={'artist'}
                    title={'artist'}
                    src={artist.artist.thumbnailUrl}
                    forBreadcrumb
                  />
                  <ArtistLinks artists={[artist]} forBreadcrumb />
                  <Artist entity={artist.artist} />
                </>
              ) : (
                <MobileArtistElement artist={artist.artist} topic={topic} />
              )}
            </ArtistElement>
          )
        )
      ) : (
        <BreadcrumbLoader isMobile={isMobile} />
      )}
    </BreadcrumbWrapper>
  );
};

const MobileArtistElement = (props: any): JSX.Element | null => {
  const { artist, topic } = props;

  if (!artist) return null;

  return (
    <>
      <MobileAnchor
        to={getEntityUrl({
          entityType: artist.type,
          entityId: artist.id,
          topic: topic.join('/'),
        })}
      >
        <>
          <CaretIcon />

          <Artwork
            key={`entity-artwork-${artist.id}`}
            entityId={artist.id}
            entityType={'artist'}
            title={'artist'}
            src={artist.thumbnailUrl}
            forBreadcrumb
          />
          <span>{artist.displayName}</span>
        </>
      </MobileAnchor>
    </>
  );
};

export default Breadcrumbs;
